module.exports = "/assets/data/7c70bf80e5cecaf674de1e9ffdb0d81a-BN27.data.json";